module.exports = __webpack_public_path__ + "img/eyebrow_male_straight_thin.86f8d3c2.png";